module.exports = __webpack_public_path__ + "static/Carol-7d72541f0c38d729970751e2da4ce843.jpg";